import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ContactFilter} from 'nutshell-graphql-types';
import type {
    GetChatbotReport as GetChatbotReportQuery,
    GetChatbotReportVariables,
} from 'nutshell-graphql-types';

import GET_CHATBOT_REPORT from '../queries/get-chatbot-report.graphql';

export function useGetChatbotReport(
    period: string,
    contactFilter?: ContactFilter,
    skip: boolean = false
) {
    const {data, error, loading} = useQuery<GetChatbotReportQuery, GetChatbotReportVariables>(
        GET_CHATBOT_REPORT,
        {
            variables: {period, contactFilter},
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    const report = data?.chatbotReport ?? null;

    return {
        report,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
